export default __webpack_public_path__ + "static/media/a011-example11_sc.1d727733.png";